import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FunctionDto, CompanyDto } from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-companyfunction-container',
  templateUrl: './companyfunction-container.component.html',
  styleUrls: ['./companyfunction-container.component.scss'],
})
export class CompanyFunctionContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  companies$: Observable<CompanyDto[]>;
  companyfunctions$: Observable<FunctionDto[]>;
  loading: boolean;
  isLoadingCompany$: Observable<boolean>;
  isLoadingCompanyFunction$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingCompany$ = this.gatwayFacade.isLoadingGateway('Company');
    this.isLoadingCompanyFunction$ = this.gatwayFacade.isLoadingGateway(
      'Function'
    );

    this.companies$ = this.gatwayFacade.loadGateway('Company');
    this.companyfunctions$ = this.gatwayFacade.loadGateway('Function');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCompanyFunction(deletedValue: any) {
    this.gatwayFacade.remove('Function', deletedValue);
  }

  // this method control both the create and update
  onSubmitCompanyFunction(formValue: any) {
    console.log(formValue);
    const pullData = formValue.CompanyFunctions;

    // declare two empty array to hold update and create data
    const allUpdates = [];
    const addAllCompanyFunction = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id) {
        allUpdates.push(pullData[i]);
      } else {
        addAllCompanyFunction.push(pullData[i]);
      }
    }

    // check if the addAllCompanyFunction array is not empty, then dispatch the data to the store
    if (addAllCompanyFunction.length > 0) {
      this.gatwayFacade.add('Function', addAllCompanyFunction);
    }

    // dispatch update data to the store
    if (allUpdates.length > 0) {
      this.gatwayFacade.update('Function', allUpdates, ['id']);
    }
  }
}
